'use client';
import { useEffect } from 'react';

export default function ClientErrorHandler() {
  useEffect(() => {
    const handler = (e) => {
      const reason = e?.reason || e;
      const message =
        reason?.message ||
        reason?.toString?.() ||
        e?.message ||
        "";

      // Only reload on REAL chunk failures
      const isChunkError =
        message.includes("ChunkLoadError") ||
        message.includes("Loading chunk") ||
        message.includes("failed to fetch dynamically imported") ||
        message.includes("Unexpected token '<'"); // corrupted JS file

      if (isChunkError) {
        // Prevent infinite reloads
        if (!sessionStorage.getItem("chunk-reloaded")) {
          sessionStorage.setItem("chunk-reloaded", "1");
          window.location.reload();
        }
      }
    };

    window.addEventListener("error", handler);
    window.addEventListener("unhandledrejection", handler);

    return () => {
      window.removeEventListener("error", handler);
      window.removeEventListener("unhandledrejection", handler);
    };
  }, []);

  return null;
}
